import {createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';

// Define a type for the slice state
export interface WaypointState {
  north: string
  east: string
  typing: boolean
}

// Define the initial state using that type
const initialState: WaypointState = {
  north: "",
  east: "",
  typing: false
}

export const WaypointSlice = createSlice({
  name: 'Waypoint',
  initialState,
  reducers: {
    setWaypoint: (state, action: PayloadAction<string>)=>{
      if(!state.typing){
        let data = action.payload;
        state.north = data[0];
        state.east = data[1];
      }
    },
    editWaypoint: (state, action: PayloadAction<any, string>)=>{
      if(action.payload.dir == "N")
        state.north = action.payload.data;
      else{
        state.east = action.payload.data;
      }
    },
    startTyping: (state)=>{
      if(!state.typing){
        state.typing = true;
      }
    },
    stopTyping: (state)=>{
      if(state.typing){
        state.typing = false;
      }
    }
   
  },
});
    

export const { setWaypoint, editWaypoint, startTyping, stopTyping} = WaypointSlice.actions

export const selectCount = (state: RootState) => state.MOTD.motd;

export default WaypointSlice.reducer